import type { GetRegisterResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getRegister = async (lang?: string) => {
    return await getGenericEndpoint<GetRegisterResponse>('register', lang);
};
